import {
  BrowserRouter,
  Route,
  Routes,
} from 'react-router-dom'

import StudioHomePage from 'pages/Studio/Home'
import RuanicaHomePage from 'pages/Ruanica/Home'
import RuanicaExplorePage from 'pages/Ruanica/Explore'
import GrimtileHomePage from 'pages/Grimtile/Home'
import FeedbackPage from 'pages/Feedback'
import TermsPage from 'pages/Terms'
import PrivacyPage from 'pages/Privacy'
import LicensesPage from 'pages/Licenses'

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StudioHomePage />} />
          <Route path="/ruanica" element={<RuanicaHomePage />} />
          <Route path="/ruanica/explore" element={<RuanicaExplorePage />} />
          <Route path="/grimtile" element={<GrimtileHomePage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/terms-of-service" element={<TermsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/licenses" element={<LicensesPage />} />

          <Route
            path="*"
            element={
              <main style={{ padding: "1rem" }}>
                <p>There's nothing here!</p>
              </main>
            }
          />
        </Routes>
      </BrowserRouter>
  )
}

export default App
